import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

export default function BxumForm({ initialValues, onSubmit, submitting }) {
  // valori implicite sigure
  const safeInit = initialValues || { cod: "", descriere: "", zecimale: 0, um_saft: "" };

  const [form, setForm] = useState(safeInit);
  const [errors, setErrors] = useState({});

  // când vine payloadul la Edit (după fetch), rehidratează formularul
  useEffect(() => {
    setForm(initialValues || { cod: "", descriere: "", zecimale: 0, um_saft: "" });
  }, [initialValues]);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const validate = () => {
    const e = {};
    if (!form.cod || !String(form.cod).trim()) e.cod = "Codul este obligatoriu.";
    // zecimale numeric (0..6) – ajustează după regulile tale
    const z = Number(form.zecimale);
    if (Number.isNaN(z) || z < 0 || z > 6) e.zecimale = "Zecimale trebuie să fie între 0 și 6.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    // coercie numerică la submit
    const payload = { ...form, zecimale: Number(form.zecimale) || 0 };
    onSubmit?.(payload);
  };

  return (
    <Form onSubmit={submit}>
      <Row className="g-3">
        <Col md={3}>
          <Form.Group controlId="bxum_cod">
            <Form.Label>Cod *</Form.Label>
            <Form.Control
              value={form.cod ?? ""}
              onChange={(e) => setField("cod", e.target.value)}
              isInvalid={!!errors.cod}
            />
            <Form.Control.Feedback type="invalid">{errors.cod}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={5}>
          <Form.Group controlId="bxum_descriere">
            <Form.Label>Descriere</Form.Label>
            <Form.Control
              value={form.descriere ?? ""}
              onChange={(e) => setField("descriere", e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col md={2}>
          <Form.Group controlId="bxum_zecimale">
            <Form.Label>Zecimale</Form.Label>
            <Form.Control
              type="number"
              min={0}
              max={6}
              step={1}
              value={form.zecimale ?? 0}
              onChange={(e) => setField("zecimale", e.target.value)}
              isInvalid={!!errors.zecimale}
            />
            <Form.Control.Feedback type="invalid">{errors.zecimale}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={2}>
          <Form.Group controlId="bxum_um_saft">
            <Form.Label>UM SAFT</Form.Label>
            <Form.Control
              value={form.um_saft ?? ""}
              onChange={(e) => setField("um_saft", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end mt-4">
        <Button type="submit" variant="dark" disabled={!!submitting}>
          {submitting ? "Se salvează…" : "Salvează"}
        </Button>
      </div>
    </Form>
  );
}
